import { from, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export function fetchWithErrorHandling<T>(
  url: string,
  options: RequestInit
): Observable<T> {
  const fetchPromise = fetch(url, options)
    .then(async (response) => {
      if (!response.ok) {
        const errorBody = await response.json().catch(() => ({}));
        throw {
          status: response.status,
          statusText: response.statusText,
          body: errorBody
        };
      }
      return response.json();
    });

  return from(fetchPromise).pipe(
    catchError((error) => {
      console.error('Error en fetchWithErrorHandling:', error);
      const mappedError = {
        status: error.status || 500,
        message: error.body?.errorMessage
      };
      return throwError(() => mappedError);
    })
  );
}
